var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { css: false },
      on: {
        enter: _vm.enter,
        leave: _vm.leave,
        "enter-cancelled": _vm.enterCancelled,
        "leave-cancelled": _vm.leaveCancelled,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.getters["loader/status"],
              expression: "$store.getters['loader/status']",
            },
          ],
          ref: "loader",
          staticClass: "loadingCircleWrap",
        },
        [
          _c("div", { staticClass: "loaderCircleUnit" }, [
            _c("div", { staticClass: "loaderCircle" }, [_vm._v("Loading...")]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }